module.exports = __webpack_public_path__ + "DINNextLTPro-BoldItalic.woff?ee8b64ffcf72a2f5946572a8adfbb048";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldItalic.woff
// module id = 1383
// module chunks = 0